import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { DeliveryDetail } from "@/pages/business/BusinessPortal";
import { api, errMsg } from "@/lib/api";

export default function TrackPage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(() => api.get(`/track/${token}`).then(({ data }) => setD(data)).catch((e) => setError(errMsg(e))), [token]);
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [load]);
  return (
    <div className="min-h-screen bg-[#0a0a0c] px-4 py-6 text-zinc-200" data-testid="track-page">
      <div className="mx-auto max-w-2xl space-y-4">
        <Logo />
        <h1 className="text-2xl font-semibold text-amber-50">Track your delivery</h1>
        {error && <p data-testid="track-error" className="text-sm text-red-300">{error}</p>}
        {!d && !error && <Loader2 className="h-5 w-5 animate-spin text-amber-400" />}
        {d && <DeliveryDetail d={d} testPrefix="track" paidBanner={new URLSearchParams(window.location.search).get("paid") === "1"} />}
        <p className="text-xs text-zinc-500">Questions? Call <a href="tel:+12145062525" className="text-amber-300">214-506-2525</a>.</p>
      </div>
    </div>
  );
}
